module.exports = __webpack_public_path__ + "img/icon_map_62_off_101.95248974.png";